export default __webpack_public_path__ + "static/media/filter-icon.ebfd2d06.svg";